import { useEffect, useState } from 'react'

import { InsuranceApi } from 'shared/api/insurance'

import { InsuranceTripPurpose } from '../../../model/types'

export const useInsurancePurposes = (
  purposes: InsuranceTripPurpose[] | null,
  onPurposesLoaded: (purposes: InsuranceTripPurpose[]) => void,
) => {
  const [isLoading, setIsLoading] = useState(purposes === null)
  const [isError, setIsError] = useState(false)
  const [retryKey, setRetryKey] = useState(0)

  useEffect(() => {
    if (purposes !== null) {
      setIsLoading(false)
      setIsError(false)
      return
    }

    const abortController = new AbortController()

    const loadPurposes = async () => {
      setIsLoading(true)
      setIsError(false)

      try {
        const { data } = await InsuranceApi.getPurposes(abortController.signal)

        if (abortController.signal.aborted) return

        onPurposesLoaded(
          data.data.map(
            ({ id, name_ru, name_kg, name_en, default: isDefault }) => ({
              id,
              nameRu: name_ru,
              nameKg: name_kg,
              nameEn: name_en,
              isDefault,
            }),
          ),
        )
      } catch {
        if (!abortController.signal.aborted) setIsError(true)
      } finally {
        if (!abortController.signal.aborted) setIsLoading(false)
      }
    }

    loadPurposes()

    return () => abortController.abort()
  }, [onPurposesLoaded, purposes, retryKey])

  return {
    purposes: purposes || [],
    isLoading,
    isError,
    retry: () => setRetryKey((current) => current + 1),
  }
}
